import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import Loader from "./commonComponent/Loader/Loader";
import SeeMore from "./screens/HomeScreen/SeeMore";
import SeeMoreSpecialOffers from "./screens/HomeScreen/SeeMoreSpecialOffers";
import PaymentPage from "./screens/Thanku/component/PaymentPage";
import OrderConfirmed from "./screens/Thanku/component/OrderConfirmation";
import QuizQuestionPage from "./screens/Questions/component/QuizQuestionPage";
import style from "./screens/Thanku/css/Thanku.module.css";
import { Link } from "react-router-dom";
import AdminLogin from "./screens/Thanku/component/AdminLogin";
import AdminDashboard from "./screens/Thanku/component/AdminDashboard";
import UAParser from "ua-parser-js";
import { ErrorHandling } from "./State";
import { offerEvent } from "./utils/api";
import Leadership from "./screens/Thanku/component/Leadership";
import ContactUs from "./screens/Thanku/component/ContactUs";
import UTRDispenseCode from "./screens/Home/component/UTRDispenseCode";
import UTRInfo from "./screens/Home/component/UTRInfo";
import RakhiChallenge from "./screens/Thanku/component/RakhiChallenge";
import RakhiQuiz from "./screens/Questions/component/RakhiQuiz";

const FanduOffers = lazy(
  () => import("./screens/Questions/component/FanduOffers"),
);
const Rewards = lazy(() => import("./screens/Thanku/component/Rewards"));
const Survey = lazy(() => import("./screens/Questions/component/Survey"));
const Home = lazy(() => import("./screens/Home"));
const SuccessFail = lazy(() => import("./screens/SuccessFail"));
const Success = lazy(
  () => import("./screens/SuccessFail/component/OtherSuccess"),
);
const TestSuccess = lazy(
  () => import("./screens/SuccessFail/component/TestSuccess"),
);
const Fail = lazy(() => import("./screens/SuccessFail/component/Fail"));
const UpiPage = lazy(() => import("./screens/UpiPage/component/UpiPage"));
const Terms = lazy(() => import("./screens/Compliance"));
const ViewCart = lazy(() => import("./screens/ViewCart/component/ViewCart"));
const Upi = lazy(() => import("./screens/UpiPayment"));
const Offer = lazy(() => import("./screens/Offer"));
const OfferLanding = lazy(
  () => import("./screens/Questions/component/FanduOffers"),
);
const Login = lazy(() => import("./screens/Login"));
const Questions = lazy(() => import("./screens/Questions"));
const Thanku = lazy(() => import("./screens/Thanku"));
const PayThanku = lazy(() => import("./screens/PayoutThanku"));
const Congrats = lazy(() => import("./screens/Congratulation"));
const UserDetails = lazy(
  () => import("./screens/Questions/component/UserDetails"),
);
const QuizRules = lazy(() => import("./screens/Questions/component/QuizRules"));
const CategoryPage = lazy(
  () => import("./screens/HomeScreen/Category/CategoryPage"),
);
const ProductDetails = lazy(
  () => import("./screens/Thanku/component/ProductDescription"),
);
const RedeemHistory = lazy(
  () => import("./screens/Thanku/component/RedeemHistory"),
);
const HotDeals2 = lazy(() => import("./screens/Thanku/component/HotDeals2"));

export default function Routing() {
  let mId = localStorage.getItem("mId") || "2026";

  let uuid = localStorage.getItem("uuid");

  let session_id = localStorage.getItem("session_id");
  const offerRequestData = (eventMetaData) => {
    try {
      const parser = new UAParser();

      const result = parser.getResult();

      return {
        machine_id: mId || "",
        device_id: uuid || "",
        session_id: session_id || "",
        ip_address: localStorage.getItem("ip_address") || "",
        lat: "",
        lng: "",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        deviceBrand: result?.device?.vendor || "Unknown",
        deviceModel: result?.device?.model || "Unknown",
        deviceType: result?.device?.type || "desktop",
        osName: result?.os?.name || "Unknown",
        osVersion: result?.os?.version || "Unknown",
        browserName: result?.browser?.name || "Unknown",
        browserVersion: result?.browser?.version || "Unknown",
        event_ts: Date.now().toString(),
        user_id: localStorage.getItem("userId") || "",
        ...eventMetaData,
      };
    } catch (error) {
      ErrorHandling("Unable to collect device information");

      return null;
    }
  };
  const avail = async (EventName, EventSubName, EventType, EventSubType) => {
    try {
      const requestData = offerRequestData({
        Event_Name: EventName,
        Event_Sub_Name: EventSubName,
        Event_Type: EventType,
        Event_Sub_Type: EventSubType,
      });

      if (!requestData) return;

      await offerEvent(requestData);
    } catch (error) {
      console.log("Offer Event Error:", error);
    }
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/see-more"
          element={
            <Suspense fallback={<Loader />}>
              <SeeMore />
            </Suspense>
          }
        />
        <Route
          path="/direct-pay"
          element={
            <Suspense fallback={<Loader />}>
              <UpiPage />
            </Suspense>
          }
        />
        <Route
          path="/special-offers"
          element={
            <Suspense fallback={<Loader />}>
              <SeeMoreSpecialOffers />
            </Suspense>
          }
        />
        <Route
          path="/ptresponse/"
          element={
            <Suspense fallback={<Loader />}>
              <SuccessFail />
            </Suspense>
          }
        />
        <Route
          path="/success/"
          element={
            <Suspense fallback={<Loader />}>
              {/* Apply the OpenInSafariPrompt to display the prompt on this route */}
              <>
                <Success />
              </>
            </Suspense>
          }
        />
        <Route
          path="/test/admin/success/"
          element={
            <Suspense fallback={<Loader />}>
              <>
                <TestSuccess upiStatus={1} />
              </>
            </Suspense>
          }
        />
        <Route
          path="/fail/"
          element={
            <Suspense fallback={<Loader />}>
              <Fail />
            </Suspense>
          }
        />
        <Route
          path="/redeem-history/"
          element={
            <Suspense fallback={<Loader />}>
              <RedeemHistory />
            </Suspense>
          }
        />
        <Route
          path="/view-cart/"
          element={
            <Suspense fallback={<Loader />}>
              <ViewCart />
            </Suspense>
          }
        />
        <Route
          path="/fandu-offers/"
          element={
            <Suspense fallback={<Loader />}>
              <FanduOffers />
            </Suspense>
          }
        />
        <Route
          path="/quiz-categories/"
          element={
            <Suspense fallback={<Loader />}>
              <QuizRules />
            </Suspense>
          }
        />
        <Route
          path="/quiz-categories/:categoryId"
          element={
            <Suspense fallback={<Loader />}>
              <QuizQuestionPage />
            </Suspense>
          }
        />
        <Route
          path="/user-details/"
          element={
            <Suspense fallback={<Loader />}>
              <UserDetails />
            </Suspense>
          }
        />
        <Route
          path="/:machineType/:mId/"
          element={
            <Suspense fallback={<Loader />}>
              <>
                {/* <OpenInSafariPrompt /> */}
                <Home />
              </>
            </Suspense>
          }
        />
        <Route>
          <Route element={<WithNavbar />}>
            <Route
              path="/compliance/:status/"
              element={
                <Suspense fallback={<Loader />}>
                  <Terms />
                </Suspense>
              }
            />
            <Route
              path="/upi/"
              element={
                <Suspense fallback={<Loader />}>
                  <Upi />
                </Suspense>
              }
            />
            <Route
              path="/login/"
              element={
                <Suspense fallback={<Loader />}>
                  <Login />
                </Suspense>
              }
            />
            <Route
              path="/congrats/:userId"
              element={
                <Suspense fallback={<Loader />}>
                  <Congrats />
                </Suspense>
              }
            />
            <Route
              path="/questions/:offerType/"
              element={
                <Suspense fallback={<Loader />}>
                  <Offer />
                </Suspense>
              }
            />
            <Route
              path="fandu-offers/category/:categoryName"
              element={
                <Suspense fallback={<Loader />}>
                  <CategoryPage />
                </Suspense>
              }
            />

            <Route
              path="see-more/:categoryName"
              element={
                <Suspense fallback={<Loader />}>
                  <CategoryPage />
                </Suspense>
              }
            />

            <Route
              path="/questions/"
              element={
                <Suspense fallback={<Loader />}>
                  <Offer />
                </Suspense>
              }
            />
            <Route
              path="/offerLanding/"
              element={
                <Suspense fallback={<Loader />}>
                  <OfferLanding />
                </Suspense>
              }
            />
            <Route
              path="/quiz-questions/"
              element={
                <Suspense fallback={<Loader />}>
                  <Questions />
                </Suspense>
              }
            />
            <Route
              path="/payment-mode/"
              element={
                <Suspense fallback={<Loader />}>
                  <PaymentPage />
                </Suspense>
              }
            />
            <Route
              path="/order-confirmed/"
              element={
                <Suspense fallback={<Loader />}>
                  <OrderConfirmed />
                </Suspense>
              }
            />
            <Route
              path="/thanku/"
              element={
                <Suspense fallback={<Loader />}>
                  <Thanku />
                </Suspense>
              }
            />
            <Route
              path="/survey/"
              element={
                <Suspense fallback={<Loader />}>
                  <Survey />
                </Suspense>
              }
            />
            <Route
              path="/rewards/"
              element={
                <Suspense fallback={<Loader />}>
                  <Rewards />
                </Suspense>
              }
            />

            <Route
              path="/leadership/"
              element={
                <Suspense fallback={<Loader />}>
                  <Leadership />
                </Suspense>
              }
            />
            <Route
              path="/contact-us/"
              element={
                <Suspense fallback={<Loader />}>
                  <ContactUs />
                </Suspense>
              }
            />
            <Route
              path="/hot-deals/"
              element={
                <Suspense fallback={<Loader />}>
                  <HotDeals2 />
                  <div
                    className={style.buttonContainer}
                    style={{ marginTop: "0px" }}
                  >
                    <Link
                      to="/fandu-offers"
                      className={style.viewOtherOffers}
                      onClick={() =>
                        avail(
                          "Fandu_Offers_Hot_Deals",
                          "Hot_Deals",
                          "Click",
                          "Hot_Deals_Page",
                        )
                      }
                    >
                      Fandu Offers
                    </Link>
                  </div>
                </Suspense>
              }
            />
            <Route
              path="/product-details/:productId/"
              element={
                <Suspense fallback={<Loader />}>
                  <ProductDetails />
                </Suspense>
              }
            />

            <Route
              path="/admin/login"
              element={
                <Suspense fallback={<Loader />}>
                  <AdminLogin />
                </Suspense>
              }
            />

            <Route
              path="/admin/dashboard"
              element={
                <Suspense fallback={<Loader />}>
                  <AdminDashboard />
                </Suspense>
              }
            />

            <Route
              path="/pthanku/"
              element={
                <Suspense fallback={<Loader />}>
                  <PayThanku />
                </Suspense>
              }
            />
            <Route
              path="/dispense-code/"
              element={
                <Suspense fallback={<Loader />}>
                  <UTRDispenseCode />
                </Suspense>
              }
            />
            <Route
              path="/utr-info/"
              element={
                <Suspense fallback={<Loader />}>
                  <UTRInfo />
                </Suspense>
              }
            />
            <Route
              path="/janmashtmi-contest/"
              element={
                <Suspense fallback={<Loader />}>
                  <RakhiChallenge />
                </Suspense>
              }
            />
            <Route
              path="/janmashtmi-quiz/:category"
              element={
                <Suspense fallback={<Loader />}>
                  <RakhiQuiz />
                </Suspense>
              }
            />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

function WithNavbar() {
  return (
    <>
      {/* <NavBar /> */}
      <Outlet />
    </>
  );
}
